import _ from 'lodash';

class ConfiguretwitterController {
  constructor(User) {
    "ngInject";
    this.name = 'connecthelpscout';
    this.User = User;
    this.settings = {};
    this.settings.keywords = [{
      value: ''
    }];
  }

  $onInit() {
    this.User
      .getTwitterSettings()
      .$loaded()
      .then((twitterSettings) => {
        if (twitterSettings.length > 0) {
          this.settings.keywords = _.map(twitterSettings, (settings) => {
            return {
              value: settings.$value
            }
          })
        } else {
          this.settings.keywords = twitterSettings;
          this.addNewURL();
        }
      })
      .catch((err) => {
        console.log(err);
      })
  }

  save() {
    // this.User
    //   .connectHelpscout(this.apiKey)
    //   .then((response) => {
    //     this.dismiss();
    //   })
    //   .catch((err) => {
    //     console.log(err);
    //   })


    let values = _.map(this.settings.keywords, (keyword) => {
      return keyword.value;
    })

    let finalValues = _.filter(values, function(o) {
      return o != '';
    });

    this.User.updateTwitterSettings(finalValues).then(() => {
      this.dismissModal();
    });
  }

  addNewURL() {
    this.settings.keywords.push({
      value: ''
    });
  }

  removeNewURL($index) {
    this.settings.keywords.splice($index, 1);
  }

  showAddChoice(choice) {
    return choice.id === this.settings.keywords[this.settings.keywords.length - 1].id;
  }

  dismissModal() {
    this.dismiss({
      $value: 'cancel'
    });
  }
}

export default ConfiguretwitterController;



// WEBPACK FOOTER //
// ./client/app/components/home/modals/configuretwitter/configuretwitter.controller.js